import PropTypes from 'prop-types';

export const permissionsType = PropTypes.objectOf(PropTypes.oneOf(['Read', 'ReadWrite', 'None']));
